export default (value, decimals = 2, signDisplay = 'never') => {
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    signDisplay,
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value ?? 0);
};
